import React from "react";
import FileOverview from "../../../fileupload/FileOverview";
import cropr from "../../../shared/utils/cropr";
import { convertAttachmentIds } from "../../../fileupload/utils";
import gettext from "../../../shared/utils/gettext";

const ImageGallery = () => {
  const imageList = cropr.images.models.sort((a, b) =>
    a.get("last_modified") > b.get("last_modified") ? 1 : -1
  );
  const attachments = convertAttachmentIds(imageList.map((i) => i.id));
  return (
    <div className="container-fluid clearfix">
      <div className="row p-2">
        <div className="col">
          <h3 className="mb-3">{gettext("Image gallery")}</h3>
          <FileOverview
            attachments={attachments}
            permission={cropr.permissions.farm}
            editable={false}
            destroyable={true}
            showAttachedTo={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
